<template>
  <div id="accounting-container">
    <div id="main-container">
      <Nav navOptionChosen="accounting"></Nav>
      <section class="main-section col-between">
        <div>
          <TitleSection title="Contabilidad" :loading="loading"></TitleSection>
          <section class="h1_8em row-between">
            <div class="search-container">
              <input
                class="input input-text input-search"
                type="text"
                placeholder="Buscar"
                v-model="search_by"
              />
            </div>
          </section>
          <table class="table-data">
            <thead>
              <tr>
                <th>Id viaje</th>
                <th>Viaje</th>
                <th>Ingresos</th>
                <th>Gastos</th>
                <th>Utilidades</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr
                :class="{ 'bg-wrong': trip.trip_canceled_at }"
                v-for="trip in trips"
                :key="trip.id"
              >
                <td>{{ trip.trip_number }}</td>
                <td>{{ trip.name }}</td>
                <td>${{ trip.revenue }}</td>
                <td>${{ trip.expenses }}</td>
                <td>
                  {{
                    trip.income >= 0
                      ? `$${trip.income}`
                      : `-$${Math.abs(trip.income)}`
                  }}
                </td>
                <td
                  class="dots"
                  @click="showOption(trip.id)"
                  @focusout="showOption(null)"
                  tabindex="-1"
                >
                  <div class="col-center">
                    <div class="optionDot"></div>
                    <div class="optionDot"></div>
                    <div class="optionDot"></div>
                  </div>
                  <div v-if="optionsActive === trip.id" class="recordOptions">
                    <div
                      class="recordOption"
                      @click="
                        this.$router.push({
                          name: 'reservations',
                          query: { search_by: trip.trip_number },
                        })
                      "
                    >
                      Ver reservaciones
                    </div>
                    <div
                      class="recordOption"
                      @click="this.$router.push(`trips/${trip.id}/bills`)"
                    >
                      Ver gastos
                    </div>
                    <div
                      class="recordOption"
                      @click="
                        this.$router.push({
                          name: 'new-trip-bill',
                          params: { id: trip.id },
                        })
                      "
                    >
                      Añadir gasto
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <Pagination
          :per_page="per_page"
          :total_items="total_items"
          :search_by="search_by"
          @new-page="loadTable"
        >
        </Pagination>
      </section>
    </div>
  </div>
</template>

<script>
import _ from "lodash";

//Components
import Nav from "../../components/Nav.vue";
import TitleSection from "../../components/TitleSection.vue";
import Pagination from "../../components/Pagination.vue";

// Services
import { index, total_items } from "@/services/trips";

export default {
  name: "AccountingView",
  data: function () {
    return {
      loading: [],
      search_by: null,
      trips: [],
      per_page: 7,
      total_items: null,
      optionsActive: null,
    };
  },
  watch: {
    search_by: function () {
      this.debouncedLoadTable();
    },
  },
  created() {
    this.setPerPage();
    this.loadTable(1);
    this.debouncedLoadTable = _.debounce(() => {
      this.loadTable(1);
    }, 500);
  },
  methods: {
    loadTable: async function (page) {
      this.trips = [];
      this.loading.push(true);
      try {
        let response = await index(this.search_by, this.per_page, page);
        this.trips = response.data.data;
        response = await total_items(this.search_by);
        this.total_items = response.data.data.total_items;
      } catch (err) {
        console.log(err);
      } finally {
        this.loading.pop();
      }
    },
    showOption: function (id) {
      if (this.optionsActive != id) this.optionsActive = id;
      else this.optionsActive = null;
    },
    setPerPage: function () {
      if (window.innerHeight <= 450) this.per_page = 5;
      else if (window.innerHeight <= 600) this.per_page = 6;
      else if (window.innerHeight <= 750) this.per_page = 7;
    },
  },
  components: {
    Nav,
    TitleSection,
    Pagination,
  },
};
</script>

<style lang="scss" scoped>
#accounting-container {
  width: 100%;
  height: auto;
  background-color: rgb(13, 13, 62);
  color: rgb(144, 144, 144);
}

#main-container {
  width: 100%;
  display: flex;
}
</style>
